"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  align-self: flex-end;\n\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 1.5rem 0;\n\n  position: relative;\n  z-index: 2;\n\n  & > * {\n    margin: 0 1rem;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.2);\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: var(--color-grey-dark-1);\n  font-weight: initial;\n  position: relative;\n  z-index: 2;\n  background-color: #fff;\n  padding: 1.5rem;\n  border: 1px solid var(--color-grey-dark-4);\n  border-radius: 3px;\n  box-shadow: var(--box-shadow-default);\n  overflow: hidden;\n\n  min-height: 5rem;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  max-width: 50rem;\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var core_1 = require("@material-ui/core");

var styles_1 = require("@material-ui/styles");

exports.StyledWrapperDiv = styled_components_1.default.div(_templateObject());
exports.StyledEditorWrapperDiv = styled_components_1.default.div(_templateObject2());
exports.StyledOverlayDiv = styled_components_1.default.div(_templateObject3());
exports.StyledButtonBoxDiv = styled_components_1.default.div(_templateObject4());
exports.StyledSaveButton = styles_1.styled(core_1.Button)({
  // Ikitsuke-clinc 側で style が上書きされてしまっているので specificity をあげて対応
  '&[class]': {
    backgroundColor: 'var(--color-grey-light-1)',
    color: 'var(--color-primary)',
    border: '1px solid var(--color-primary)',
    fontSize: 'var(--font-size-medium)',
    padding: '.75rem 1rem',
    fontWeight: 'bold',
    boxShadow: "var(--box-shadow-default)",
    '&:hover': {
      backgroundColor: 'var(--color-grey-light-4)'
    }
  }
});